module.exports = __webpack_public_path__ + "static/media/021.88c6f923.jpg";